module.exports = __webpack_public_path__ + "static/media/dealer.de240f28.svg";